import { Typography } from "@packages/ds";
import styled from "styled-components";

import { CloseButton } from "ds/Button";

export const StyledDescription = styled(Typography.BodyText)`
  margin-top: 16px;
`;

export const Layout = styled.div`
  padding-top: 32px;
  padding-right: 32px;
  padding-bottom: 32px;
  padding-left: 32px;

  position: relative;
`;

export const Text = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 22px;
  color: var(--section-ebony-light-color, var(--ebony-light));
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const ButtonRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

export const Heading = styled.div`
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: var(--header-ebony-color, var(--ebony));
`;

export const StyledCloseButton = styled(CloseButton)`
  position: absolute;
  top: 16px;
  right: 16px;
`;
